var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value || this.$slots.default)?_c('div',{staticClass:"info-row"},[_c('p',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"values"},[_vm._t("default",[_c('p',[_vm._v(_vm._s(_vm.value))])])],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }